var ImageGroupDto = (function () {
    function ImageGroupDto(view_type, images, variationAttributes) {
        if (view_type === void 0) { view_type = ""; }
        if (images === void 0) { images = []; }
        this.view_type = view_type;
        this.images = images;
        this.variationAttributes = variationAttributes;
    }
    ImageGroupDto.fromOcapi = function (ocapiImageGroup) {
        var images = ocapiImageGroup.images.map(function (m) { return ({
            dis_base_link: m.dis_base_link,
            alt: m.alt,
            title: m.title
        }); });
        return new ImageGroupDto(ocapiImageGroup.view_type, images, ocapiImageGroup.variation_attributes);
    };
    return ImageGroupDto;
}());
export { ImageGroupDto };
//# sourceMappingURL=ImageGroupDto.js.map